<template>
  <b-button
    variant="outline-primary"
    size="sm"
    @click="play"
  >
    <feather-icon
      v-if="!isPlaying"
      class="PlayCircleIcon resposive-icon"
      size="26"
      icon="PlayCircleIcon"
    />
    <feather-icon
      v-else
      class="PauseCircleIcon resposive-icon"
      size="26"
      icon="PauseCircleIcon"
    />
  </b-button>
</template>

<script>
import { BButton } from "bootstrap-vue";

export default {
  props: {
    voice: {
      type: Object,
      required: true,
    },
  },
  components: {
    BButton,
  },
  data() {
    return {
      isPlaying: false,
      audio: null,
    };
  },
  methods: {
    play() {
      const _this = this;
      if (!this.audio) {
        this.audio = new Audio(this.voice.url);
        this.audio.addEventListener("ended", function () {
          _this.isPlaying = false;
        });
        this.audio.play();
      } else {
        if (!this.isPlaying) {
          this.audio.play();
        } else {
          this.audio.pause();
        }
      }

      this.isPlaying = !this.isPlaying;
    },
  },
};
</script>
